export const endpoints = {
  userExternalAccounts: '/users/{userId}/external-accounts',
  userExternalAccount: '/users/{userId}/external-accounts/{id}',
  messageRateLimitCapacity: '/messages/rate-limit-capacity',
} as const;
